export default "__VITE_ASSET__71f92761__"